var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalSteps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50046 1.49565C9.14906 3.49016 8.82827 5.48076 9 7.5C9.07467 8.37779 9.60567 9.71834 10 10.5C10.3943 11.2812 11.1558 11.8726 12 12C13.0016 12.1522 13.3892 11.9723 14 13C14.3019 13.5082 13.9314 14.4548 13.4283 14.7479C12.8278 15.0983 12.1562 14.9952 11.5015 14.9513C10.4464 14.8804 9.22653 14.9653 8.21854 14.5953C7.41261 14.2994 6.82415 13.5887 6.32529 12.8714C5.82736 12.1546 5.36303 11.3837 4.67004 10.8662C4.07458 10.4205 3.39652 10.2814 2.75113 9.9543C1.84487 9.49417 0.674019 8.62338 1.08515 7.42733C1.24755 6.95507 2.67427 5.371 3 5C4.31552 3.50342 4.25751 2.78918 5.1605 1",
    stroke: "#006FFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalSteps);
export default __webpack_public_path__ + "static/media/total-steps.13ccf52809277cbcd39f8afc4668896f.svg";
export { ForwardRef as ReactComponent };